import React from 'react';
import { useQuote, quoteActionTypes } from '../../../context/Quote';
import { useQuoteVisibility } from '../../../context/QuoteVisbility';
import { mergeClassNames } from '../../../utils';
import { useTrackCustomEvent } from '../../../utils/useTrackCustomEvent';
import { PrimaryButton } from '../../generic/Button';
import { IconTypes } from '../../generic/Icon';
import styles from './index.module.scss';

export default function FloatingQuoteButton({
  product,
  heading,
  tracking: { category, action, label },
  className = '',
}) {
  let trackCustomEvent = useTrackCustomEvent();
  let { dispatchQuote } = useQuote();
  const { toggleQuote } = useQuoteVisibility();

  let addProduct = () => {
    if (product) {
      trackCustomEvent({
        category: category,
        action: action,
        label: label,
      });
      dispatchQuote({
        type: quoteActionTypes.add,
        item: product,
      });
      toggleQuote('open');
    }
  };

  return (
    <PrimaryButton
      iconType={IconTypes.quote}
      clickHandler={addProduct}
      className={mergeClassNames(styles.floatingQuoteButton, !Boolean(product) ? styles.hidden : '', className)}
    >
      {heading}
    </PrimaryButton>
  );
}
